import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import Button from 'primitives/Button';
import { Dialog, DialogActions, DialogPanel, DialogSubTitle, DialogTitle } from 'primitives/Dialog';

const DematReminderDialog: FC<{
  investmentEntityId: string;
  open: boolean;
  onClose: () => void;
}> = ({ investmentEntityId, open, onClose }) => {
  const navigate = useNavigate();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogPanel className="sm:min-w-[560px]">
        <DialogTitle>Add your demat account details</DialogTitle>
        <DialogSubTitle>
          We don&apos;t have demat account details for this investment entity yet. Please add them
          so your units can be credited to your demat account.
        </DialogSubTitle>
        <DialogActions>
          <Button variant="secondary" onClick={onClose}>
            Remind me later
          </Button>
          <Button
            onClick={() => navigate(`/invest/investment-entities/${investmentEntityId}/demat`)}
          >
            Add demat details
          </Button>
        </DialogActions>
      </DialogPanel>
    </Dialog>
  );
};

export default DematReminderDialog;
